import React from "react";
import TextArea from "./TextArea";
import "./TopicInput.less";

interface TopicInputProps {
  topic: string;
  topicIcon: string;
  question: string;
  message: string;
  onMessageChange: (message: string) => void;
  onBackToTopics: () => void;
  onMessageInteractionStart?: () => void;
  disabled?: boolean;
  characterLimit?: number;
  backToTopicsText?: string;
  hideBackButton?: boolean;
}

const TopicInput: React.FC<TopicInputProps> = ({
  topic,
  topicIcon,
  question,
  message,
  onMessageChange,
  onBackToTopics,
  onMessageInteractionStart,
  disabled = false,
  characterLimit = 500,
  backToTopicsText = "Back to topics",
  hideBackButton = false
}) => {
  return (
    <>
      <div role="region" aria-label="Message Input">
        <div className="topic-input-wrapper">
          <div className="topic-input-header">
            <div className="topic-input-icon-wrapper" aria-hidden="true">
              <img src={topicIcon} alt="" className="topic-input-icon" />
            </div>
            <div className="topic-input-topic">{topic}</div>
          </div>
          <div
            className="topic-input-question eta"
            role="heading"
            aria-level={4}
            dangerouslySetInnerHTML={{ __html: question }}
          />

          <TextArea
            value={message}
            onChange={onMessageChange}
            characterLimit={characterLimit}
            label={`Message for ${topic}`}
            onInteractionStart={onMessageInteractionStart}
            disabled={disabled}
          />

          {!hideBackButton && (
            <button
              onClick={onBackToTopics}
              className="btn-link topic-input-back-button"
              aria-label="Return to topic selection"
            >
              <span className="arrow-glyph">←</span> {backToTopicsText}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default TopicInput;
